import { getAllBadges, getLatestTenBadges } from '@/api/badge';
import {
  getCalendarDisclaimer,
  getCalendarEventDetails,
  getCalendarEvents,
  getCountries,
  getEventSubscriptionStatus,
} from '@/api/calendar';
import {
  claimLuckyDraw,
  claimReward,
  getCampaignBanners,
  getCampaignConfig,
  getCampaignFAQs,
  getCampaignRules,
  getFirstDepositAmount,
  getLuckyDrawHistory,
  getLuckyDrawStatus,
  getMyMission,
  getPromotionCampaign,
  getRewardHistory,
  getUnredeemedCount,
  getUserRewardStatus,
} from '@/api/campaign';
import {
  createConversionQuote,
  getAdjustments,
  getBankAccountRequirements,
  getBankAccounts,
  getConversionQuote,
  getCreditCards,
  getDepositAndWithdrawal,
  getDepositDetails,
  getDepositInfo,
  getDepositLimit,
  getLiveAccountRegistrations,
  getMerchantReference,
  getPaymentDetails,
  getSignedCurrencyConversionRate,
  getTransactionHistories,
  getWithdrawalDetails,
  getWithdrawalFeeDetails,
  getWithdrawalInfo,
} from '@/api/cash';
import {
  deleteOnboardingProgress,
  deleteOnboardingProgressFile,
  getMigrationStatus,
  getOnboardingProgress,
  migrateAccount,
  submitKycForm,
  updateOnboardingProgress,
  uploadImagesForKyc,
  uploadOnboardingProgressFile,
} from '@/api/kyc';
import {
  createUserPriceAlert,
  deleteUserPriceAlert,
  getFocusedMarkets,
  getInstrumentInformationById,
  getTopMoverInstruments,
  getUserPriceAlerts,
  getWatchListInstruments,
  updateUserPriceAlert,
} from '@/api/marketData';
import { getNewsByInstrumentId } from '@/api/news';
import {
  getNotificationMessages,
  getNotificationMessageUnreadCounts,
  markAllNotificationMessagesAsRead,
  updateNotificationMessage,
} from '@/api/notification';
import {
  getAlertBanners,
  getBlogs,
  getFAQContents,
  getPromotionalModalContents,
  getPromotionBannerContents,
  getServerTime,
  getSignUpModalContents,
  getWhatsNewInfo,
  submitSupportRequest,
} from '@/api/other';
import {
  followUnfollow,
  getFollowerCognitoIds,
  getFollowerCount,
  getFollowingCognitoIds,
  getFollowingCount,
  getMostFollowers,
  getPinnedActivity,
  pinActivity,
  unpinActivity,
} from '@/api/social';
import {
  cancelOrder,
  closePosition,
  closePositions,
  createOrder,
  getActiveKaptains,
  getCopierStats,
  getFocusedMarketsStats,
  getIsFollowKaptain,
  getKopierCognitoIds,
  getKopierCount,
  getKopyingCount,
  getKopyTradeSetting,
  getKopyTradesSummary,
  getKopyTradeStatus,
  getLeaderboard,
  getLeaderboardCognitoUserFollowers,
  getMostTradedInstruments,
  getOwnTradesStats,
  getPastKaptains,
  getPastPerformance,
  getPastPerformanceTotalReturnTwr,
  getPortfolioOverview,
  getProfilePeriodPastPerformance,
  getShowProfileStats,
  getSingleKopyTradeSummary,
  getTradeNotificationSubscribe,
  getTradeNotificationSubscriberCount,
  getTraderRecordAccounts,
  getTraderRecordPortfolioOverview,
  getTraderRecordTradedInstruments,
  getTraderRecordTransactionPages,
  getTransactionPages,
  subscribeKopyTradeByUser,
  subscribeTradeNotifications,
  unsubscribeKopyTradeByUser,
  unsubscribeTradeNotifications,
  updateIsFollowKaptain,
  updateKopyTradeSetting,
  updateShowProfileStats,
} from '@/api/trading';
import {
  getUserByCognitoId,
  getUserNotificationPreferences,
  getUserTradePreferences,
  removeAvatar,
  removeCoverPic,
  updateUserNotificationPreferences,
  updateUserTradePreferences,
  uploadAvatar,
  uploadCoverPic,
} from '@/api/user';

export const AqtQuery = {
  activeKaptains: getActiveKaptains,
  adjustments: getAdjustments,
  alertBanners: getAlertBanners,
  allBadges: getAllBadges,
  bankAccountRequirements: getBankAccountRequirements,
  bankAccounts: getBankAccounts,
  blogs: getBlogs,
  calendarDisclaimer: getCalendarDisclaimer,
  calendarEventDetails: getCalendarEventDetails,
  calendarEvents: getCalendarEvents,
  campaignBanners: getCampaignBanners,
  campaignConfig: getCampaignConfig,
  campaignFAQs: getCampaignFAQs,
  campaignRules: getCampaignRules,
  conversionQuote: getConversionQuote,
  copierStats: getCopierStats,
  countries: getCountries,
  creditCards: getCreditCards,
  depositAndWithdrawal: getDepositAndWithdrawal,
  depositDetails: getDepositDetails,
  depositInfo: getDepositInfo,
  depositLimit: getDepositLimit,
  eventSubscriptionStatus: getEventSubscriptionStatus,
  firstDepositAmount: getFirstDepositAmount,
  focusedMarkets: getFocusedMarkets,
  focusedMarketsStats: getFocusedMarketsStats,
  followerCognitoIds: getFollowerCognitoIds,
  followerCount: getFollowerCount,
  followingCognitoIds: getFollowingCognitoIds,
  followingCount: getFollowingCount,
  instrumentInformation: getInstrumentInformationById,
  isFollowKaptain: getIsFollowKaptain,
  kopierCognitoIds: getKopierCognitoIds,
  kopierCount: getKopierCount,
  kopyingCount: getKopyingCount,
  kopyTradeSetting: getKopyTradeSetting,
  kopyTradesSummary: getKopyTradesSummary,
  kopyTradeStatus: getKopyTradeStatus,
  latestBadges: getLatestTenBadges,
  leaderboard: getLeaderboard,
  leaderboardCognitoUserFollowers: getLeaderboardCognitoUserFollowers,
  liveAccountRegistrations: getLiveAccountRegistrations,
  luckyDrawHistory: getLuckyDrawHistory,
  luckyDrawStatus: getLuckyDrawStatus,
  merchantReference: getMerchantReference,
  migrationStatus: getMigrationStatus,
  mostFollower: getMostFollowers,
  mostTradedInstruments: getMostTradedInstruments,
  myMission: getMyMission,
  newsByInstrumentId: getNewsByInstrumentId,
  notificationMessage: getNotificationMessages,
  notificationMessageUnreadCounts: getNotificationMessageUnreadCounts,
  onboardingProgress: getOnboardingProgress,
  ownTradesStats: getOwnTradesStats,
  pastKaptains: getPastKaptains,
  pastPerformance: getPastPerformance,
  pastPerformanceTotalReturnTwr: getPastPerformanceTotalReturnTwr,
  paymentDetails: getPaymentDetails,
  pinActivity,
  pinnedActivity: getPinnedActivity,
  priceAlerts: getUserPriceAlerts,
  profilePeriodPastPerformance: getProfilePeriodPastPerformance,
  promotionalModalContents: getPromotionalModalContents,
  promotionBannerContents: getPromotionBannerContents,
  promotionCampaign: getPromotionCampaign,
  ptFAQContents: getFAQContents,
  rewardHistory: getRewardHistory,
  serverTime: getServerTime,
  showProfileStats: getShowProfileStats,
  signedCurrencyConversionRate: getSignedCurrencyConversionRate,
  signUpModalContents: getSignUpModalContents,
  singleKopyTradeSummary: getSingleKopyTradeSummary,
  topMoverInstruments: getTopMoverInstruments,
  tradedInstruments: getTraderRecordTradedInstruments,
  tradeNotificationSubscribe: getTradeNotificationSubscribe,
  tradeNotificationSubscriberCount: getTradeNotificationSubscriberCount,
  traderRecordAccounts: getTraderRecordAccounts,
  transactionHistories: getTransactionHistories,
  transactionOverview: getPortfolioOverview,
  transactionOverviewTrader: getTraderRecordPortfolioOverview,
  transactionPages: getTransactionPages,
  transactionPagesTrader: getTraderRecordTransactionPages,
  unpinActivity,
  unredeemedCount: getUnredeemedCount,
  userByCognitoId: getUserByCognitoId,
  userNotificationPreferences: getUserNotificationPreferences,
  userRewardStatus: getUserRewardStatus,
  userTradePreferences: getUserTradePreferences,
  watchListInstruments: getWatchListInstruments,
  whatsNewInfo: getWhatsNewInfo,
  withdrawalDetails: getWithdrawalDetails,
  withdrawalFeeDetails: getWithdrawalFeeDetails,
  withdrawalInfo: getWithdrawalInfo,
};

export const AqtMutation = {
  cancelOrder,
  claimLuckyDraw,
  claimReward,
  closePosition,
  closePositions,
  createConversionQuote,
  createOrder,
  createPriceAlert: createUserPriceAlert,
  deleteOnboardingProgress,
  deleteOnboardingProgressFile,
  deletePriceAlert: deleteUserPriceAlert,
  followUnfollow,
  markAllNotificationMessagesAsRead,
  migrateAccount,
  removeAvatar,
  removeCoverPic,
  submitKycForm,
  submitSupportRequest,
  subscribeKopyTradeByUser,
  subscribeTradeNotifications,
  unsubscribeKopyTradeByUser,
  unsubscribeTradeNotifications,
  updateIsFollowKaptain,
  updateKopyTradeSetting,
  updateNotificationMessage,
  updateOnboardingProgress,
  updatePriceAlert: updateUserPriceAlert,
  updateShowProfileStats,
  updateUserNotificationPreferences,
  updateUserTradePreferences,
  uploadAvatar,
  uploadCoverPic,
  uploadImagesForKyc,
  uploadOnboardingProgressFile,
};
